import { FORM_ERROR } from 'final-form';
import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import AcceptInvitationForm from '../../components/auth/AcceptInvitationForm.jsx';
import { mapFinalFormErrors } from '../../lib/utils.js';
import { acceptInvitation } from '../../modules/auth.js';

const mapErrors = mapFinalFormErrors('Failed to set password');

const onSubmit =
  (acceptInvitation, invitationToken, organizationSlug) => (values) =>
    acceptInvitation({ invitationToken, ...values }, organizationSlug).catch(
      (error) => {
        const formErrors = mapErrors(error);
        if (formErrors.invitationToken) {
          // Use invitation token error as main error if it exists
          formErrors[FORM_ERROR] = formErrors.invitationToken;
        }
        return formErrors;
      }
    );

const validate = (values) => {
  const errors = {};

  if (!values.password) {
    errors.password = 'Password is required';
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Confirm Password is required';
  } else if (values.password !== values.passwordConfirmation) {
    errors.passwordConfirmation = 'Passwords must match';
  }

  return errors;
};

let AcceptInvitationFormContainer = ({
  acceptInvitation,
  invitationToken,
  organizationSlug,
}) => (
  <Form
    component={AcceptInvitationForm}
    onSubmit={onSubmit(acceptInvitation, invitationToken, organizationSlug)}
    validate={validate}
  />
);

AcceptInvitationFormContainer = connect(null, { acceptInvitation })(
  AcceptInvitationFormContainer
);

AcceptInvitationFormContainer.propTypes = {
  invitationToken: PropTypes.string.isRequired,
};

export default AcceptInvitationFormContainer;
